import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yd8at4aq3v: FaireBrandEntity = {
  token: "b_yd8at4aq3v",
  type: "brand",
  name: "Mid Mod Design LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/82cc2c934ab411839aa25a891a3f45f36d42e7eb89b11cb3f5dc90e50fe5f632.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7830009bcc78212606fb1aedccb1f992862a3ffbdcc1555c46bc31da6f583c83.png",
  logoUrl:
    "https://cdn.faire.com/fastly/82cc2c934ab411839aa25a891a3f45f36d42e7eb89b11cb3f5dc90e50fe5f632.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7830009bcc78212606fb1aedccb1f992862a3ffbdcc1555c46bc31da6f583c83.png",
  location: "Anderson, SC, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 17,
  isTopShop: true,
  isInsider: true,
  description:
    "I am a Wife and Mom of three and started this small art studio to be able to stay home and have more flex time with my kids, husband, and our rather large fur baby!  I have an undergrad in interior design and the fine arts and a graduate degree in business.  I love all things home decor!  Being apart of the creative process from painting these pieces, and then designing them into unique, one-of-a-kind door hangers is my passion!\n\nI have made my artwork into unique, fun, and whimsical door hangers!  These come as printed \"pieces of art\" on rigid PVC with a UV topcoat protectant applied to protect against fading from sunlight.  These are perfect for outdoors and will last for years to come with proper care!  Please read individual listings for detailed proper care instructions.  Each door hanger comes with either a single or pair of drilled hole(s) for application of a designer bow to be looped through.\n\nThese are the perfect and unique statment pieces to welcome guests into your home and to showcase your flair for design!  All of our door hangers have received five star ratings across the board and buyers absolutely love them!\n\nI also have many more options to choose from for all seasons, holidays, parties and so much more!  Do not hesitate to reach out if you're looking for something specific as I can make it happen, and that's what sets us apart from the competition - they're quite LARGE, unique, and one-of-a-kind!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:07.664Z",
    importedBy: "entity-db-cli",
  },
};
